import * as React from 'react';
import { connect } from 'react-redux';
import { RequestApiResult, requestAPIActions } from 'loopback-react-request';
import { GlobalPrivateState } from 'src/api';
import { ProjectModel } from 'src/api/models/Project/project.model';

export interface ProjectDispatcherProps {
  dispatch: any;
  id: string;
  project: RequestApiResult<ProjectModel>;
}

const dispatchKey = 'project';

class ProjectDispatcherContainer extends React.Component<ProjectDispatcherProps> {

  componentDidMount() {
    this.dispatchConfiguration();
  }

  componentDidUpdate(prevProps: ProjectDispatcherProps) {
    const project = this.props.project.result;
    const prevProj = prevProps.project.result;
    
    if (
      ((project && project.id) && (prevProj && prevProj.id)) && 
      (project && project.id !== this.props.id)
    ) {
      this.dispatchConfiguration();
    }
  } 

  public render() {
    return null;
  }

  componentWillUnmount() {
    this.props.dispatch(requestAPIActions.loadCleared(dispatchKey));
  }

  private dispatchConfiguration() {
    this.props.dispatch(requestAPIActions.load(
      dispatchKey, {
        url: `/Projects/${this.props.id}`,
      },
      true
    ));
  }
}


export const ProjectDispatcher = connect((state: GlobalPrivateState) => ({
  project: state.project,
}))(ProjectDispatcherContainer);
